@if (label) {
  <label [for]="id" class="ctv-upload-button-label">
    {{label}} @if (tooltip) {
    <i class="fas fal fa-info-circle" [matTooltip]="tooltip"></i>
  }
  @if (imageSize || imageSize === 0) {
    <span class="ml-3"><strong>{{imageSize}}MB</strong></span>
  }
</label>
}
@if (!imagePreview && !file) {
  <label [for]="id" class="ctv-upload-button">
    <span class="fal fa-upload text-primary mr-3"></span>
    <span>Upload</span>
    <input type="file" class="d-none"
      [id]="id" #fileInput
      (change)="handleFileInput($event)"
      [accept]="allowedFileTypes">
    </label>
  }
  @if (imagePreview) {
    <div class="ctv-upload-preview">
      <div class="ctv-upload-preview-image" ngClass="{{fileName ? 'col-4' : 'col-12'}}">
        <img [src]="imagePreview" alt="" width="100%">
        <div class="ctv-upload-preview-delete">
          <button type="button" mat-mini-fab color="warn" class="mat-elevation-z0" (click)="removeImage()" matTooltip="Delete">
            <i class="fal fa-trash-alt" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      @if (fileName) {
        <div class="col ctv-upload-preview-name">
          <p class="mb-0">
            <small>File name:</small> <br>
            <span>{{file.name}}</span>
          </p>
        </div>
      }
    </div>
  }
